import { Box } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import type { ReactNode } from "react";
import type { AuthBrandMode } from "../authBrandContent";
import { getAuthBrandCopy } from "../authBrandContent";
import type { LoginTr } from "../useLoginTranslations";
import styles from "./AuthSplitLayout.module.css";

export interface AuthSplitLayoutProps {
  brandMode: AuthBrandMode;
  logo?: ReactNode;
  tr: LoginTr;
  title?: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
}

export function AuthSplitLayout({ brandMode, logo, tr, title, subtitle, children }: AuthSplitLayoutProps) {
  const brand = getAuthBrandCopy(brandMode, tr);

  return (
    <Box className={styles.card}>
      <Box className={styles.brandPanel} aria-hidden={false}>
        <Box className={styles.brandCircleLg} aria-hidden />
        <Box className={styles.brandCircleMd} aria-hidden />
        <Box className={styles.brandCircleSm} aria-hidden />
        <Box className={styles.brandInner}>
          <Box className={styles.brandLogoRow}>
            {logo ?? (
              <Box className={styles.brandLogoFallback} aria-hidden>
                <IconLock size={26} />
              </Box>
            )}
            {logo == null ? (
              <Box className={styles.brandWordmark}>
                <Box className={styles.brandProductName}>{tr("login.brand.productName", "Collective Discovery")}</Box>
                <Box className={styles.brandByline}>{tr("login.brand.byline", "by Canucci")}</Box>
              </Box>
            ) : null}
          </Box>
          <Box className={styles.brandContent}>
            <Box component="p" className={styles.brandHeadline}>
              {brand.headline}
            </Box>
            <Box component="p" className={styles.brandBody}>
              {brand.body}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={styles.formPanel}>
        <Box className={styles.formInner}>
          {title != null ? (
            <Box
              component="h1"
              className={subtitle != null ? styles.formTitle : `${styles.formTitle} ${styles.formTitleNoSubtitle}`}
            >
              {title}
            </Box>
          ) : null}
          {subtitle != null ? <Box className={styles.formSubtitle}>{subtitle}</Box> : null}
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export function AuthEyebrowDivider({ label }: { label: string }) {
  return (
    <Box className={styles.eyebrowDivider}>
      <Box className={styles.eyebrowDividerLine} aria-hidden />
      <Box className={styles.eyebrowDividerLabel}>{label}</Box>
      <Box className={styles.eyebrowDividerLine} aria-hidden />
    </Box>
  );
}
